import has from 'lodash-es/has';
import set from 'lodash-es/set';
import update from 'lodash-es/update';
import moment from 'moment';

export const defaultFormats = {
	date: 'L',
	dateTime: 'L LT',
	longDate: 'LL',
	longDateTime: 'LLL'
};

const now = moment();

moment.defaultFormat = defaultFormats.dateTime;

moment.updateLocale('en', {
	longDateFormat: {
		LT: 'HH:mm',
		LTS: 'HH:mm:ss',
		L: 'DD.MM.YYYY',
		LL: 'Do MMM YYYY',
		LLL: 'LL LT',
		LLLL: 'dddd, Do MMMM YYYY LT'
	}
});

moment.locale('en-custom', {
	parentLocale: 'en'
});

export const formatDate = (m, format = defaultFormats.date) => {
	if (!m) return '';
	const d = moment.isMoment(m) ? m : moment(m);
	return d.isValid() ? d.format(format) : '';
};

export const toJavaLocalDate = m => formatDate(m, 'YYYY-MM-DD');
export const formatDateTime = m => formatDate(m, defaultFormats.dateTime);
export const formatLongDate = m => formatDate(m, defaultFormats.date);
export const formatLongDateTime = m =>
	formatDate(m, defaultFormats.longDateTime);

export const days = m => {
	if (!m) return '';
	const d = moment.isMoment(m) ? m : moment(m);
	return `${now.diff(d, 'days')} day(s) ago`;
};
export const isToday = m => {
	if (!m) return false;
	const d = moment.isMoment(m) ? m : moment(m);
	return d.isValid() && d.diff(moment(), 'days') === 0;
};

export const displayWhen = m => {
	if (!m) return '';
	const d = moment.isMoment(m) ? m : moment(m);
	return d.calendar();
};

export const displayWhenDateOnly = m => {
	if (!m) return '';
	const d = moment.isMoment(m) ? m : moment(m);
	return d.calendar(null, {
		lastDay: '[Yesterday]',
		sameDay: '[Today]',
		nextDay: '[Tomorrow]',
		lastWeek: '[last] dddd',
		nextWeek: 'dddd',
		sameElse: 'L'
	});
};

export const momentParse = dateString => {
	if (dateString) {
		const momentDate = moment(dateString);
		if (momentDate.isValid()) {
			return momentDate;
		}
	}
	return null;
};

export const parseDate = dateString => {
	if (!dateString) {
		return null;
	}
	if (typeof dateString === 'string') {
		let momentDate = moment(dateString);
		return !momentDate || !momentDate.isValid() ? moment.unix(dateString) : momentDate;
	}

	if (typeof dateString === 'number') {
		return moment.unix(dateString);
	}

	if (dateString) {
		if (dateString.epochSecond) {
			return moment.unix(dateString.epochSecond);
		}

		if (dateString.nano) {
			return moment.unix(dateString.nano * 1000);
		}
	}
	return null;

};

export const mapFieldsToMomentDate = (object, fields, parser = parseDate) => {
	const newObject = { ...object };
	fields.forEach(path => {
		if (has(newObject, path)) {
			update(newObject, path, a => {
				set(newObject, `${path}_`, a);
				return parser(a);
			});
		}
	});
	return newObject;
};

export default moment;
